export default __webpack_public_path__ + "static/media/chatgpt_example_fr.44986d1c.png";